module.exports = __webpack_public_path__ + "img/user.91e52247.png";